// Paleta curada usada como cor de fundo dos avatares de fallback (contatos
// sem foto de perfil). Tons médios, agradáveis e distintos entre si.
const AVATAR_COLORS = [
  "#2D7BE8", // azul
  "#16a34a", // verde
  "#8b5cf6", // roxo
  "#db2777", // rosa
  "#ea580c", // laranja
  "#0891b2", // ciano
  "#d97706", // âmbar
  "#dc2626", // vermelho
  "#14b8a6", // teal
  "#7c3aed", // violeta
  "#4f46e5", // índigo
  "#0d9488", // teal escuro
];

// Deriva uma cor determinística da paleta a partir de uma string (nome ou id
// do contato). O mesmo contato sempre recebe a mesma cor.
const stringToColor = (str) => {
  const value = String(str || "");
  if (!value) return AVATAR_COLORS[0];

  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
    hash |= 0; // mantém em 32 bits
  }

  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
};

export default stringToColor;
